import { commentsData } from '@/mocks/home';

export default function SectionComments() {
  return (
    <section id="comments" className="py-12 md:py-16 px-4 md:px-6 bg-background-50" style={{ scrollMarginTop: '4rem' }}>
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading font-bold text-xl md:text-2xl lg:text-3xl text-foreground-950 mb-2">
            瓜友热评
          </h2>
          <p className="text-sm text-foreground-500">精选百万瓜友的真实评论与观点</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {commentsData.map((comment, i) => (
            <div key={i} className="bg-background-50 rounded-xl p-5 border border-background-200/70">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-background-200 text-lg">
                  {comment.avatar}
                </div>
                <div className="flex-1">
                  <div className="font-medium text-sm text-foreground-950">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">{comment.content}</p>
              <div className="flex items-center gap-1 text-foreground-400 text-xs">
                <i className="ri-thumb-up-line text-sm"></i>
                <span>{comment.likes.toLocaleString()} 赞</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}